import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './CaptchaModal.css';

const CaptchaModal = ({
    isOpen,
    captchaImage,
    captchaInput,
    onInputChange,
    onRefresh,
    onSubmit,
    onClose,
    loading,
    error,
}) => {
    const inputRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return undefined;
        inputRef.current?.focus();
        const closeOnEscape = (event) => {
            if (event.key === 'Escape' && !loading) onClose();
        };
        document.addEventListener('keydown', closeOnEscape);
        return () => document.removeEventListener('keydown', closeOnEscape);
    }, [isOpen, loading, onClose]);

    if (!isOpen) return null;

    return (
        <div className="captcha-modal-overlay" role="presentation" onMouseDown={(event) => {
            if (event.target === event.currentTarget && !loading) onClose();
        }}>
            <form className="captcha-modal" role="dialog" aria-modal="true" aria-labelledby="captcha-title" onSubmit={(event) => {
                event.preventDefault();
                if (!loading) onSubmit();
            }}>
                <div className="captcha-heading">
                    <span className="captcha-shield" aria-hidden="true">✓</span>
                    <div>
                        <h2 id="captcha-title">Ещё один шаг</h2>
                        <p>Прочитайте короткий код — и готово</p>
                    </div>
                </div>

                <div className={`captcha-frame${loading ? ' is-loading' : ''}`}>
                    {captchaImage ? <img src={captchaImage} alt="Код проверки" className="captcha-image" /> : <div className="captcha-skeleton" />}
                    <button type="button" className="captcha-refresh" onClick={onRefresh} disabled={loading} aria-label="Показать другой код" title="Другой код">↻</button>
                </div>

                <label className="captcha-field">
                    <span>Код с картинки</span>
                    <input
                        ref={inputRef}
                        type="text"
                        value={captchaInput}
                        onChange={onInputChange}
                        placeholder="Введите код"
                        className="captcha-input"
                        autoComplete="off"
                        autoCapitalize="none"
                        spellCheck="false"
                        disabled={loading}
                    />
                </label>
                <div className={`captcha-message${error ? ' is-error' : ''}`} aria-live="polite">{error || 'Регистр не важен'}</div>

                <div className="captcha-actions">
                    <button type="submit" className="submit-btn" disabled={loading || !captchaInput.trim()}>{loading ? 'Проверяем…' : 'Продолжить'}</button>
                    <button type="button" onClick={onClose} className="cancel-btn2" disabled={loading}>Отмена</button>
                </div>
            </form>
        </div>
    );
};

CaptchaModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    captchaImage: PropTypes.string.isRequired,
    captchaInput: PropTypes.string.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onRefresh: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
};

export default CaptchaModal;
